'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const IdeaRepository = require('feedback/domain/repository/idea');

class IdeaRelatedCollection extends Backbone.Collection {
    fetchIdeasByIDs(ids) {
        return Promise.all(
            _.map(ids, id => IdeaRepository.fetchByID(id))
        ).then(_ideas => {
            const ideas = _.filter(_ideas, idea => idea.id);
            this.add(ideas, {merge: true});

            return this;
        });
    }
}

module.exports = IdeaRelatedCollection;



// WEBPACK FOOTER //
// ./feedback/domain/collection/idea-related.js